import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { rem, colors } from '../lib/global-styles';
import arrow from '../images/arrow.svg';

const ChannelsModalWrapper = styled.div`
  h3 {
    text-align: left;
    margin: 0 0 ${rem(30)} ${rem(10)};
    font-size: ${rem(16)};
  }
`;
const CategoriesList = styled.ul`
  margin-left: ${rem(10)};
  list-style: none;
  text-align: left;
  padding: 0;
  max-height: ${rem(500)};
  overflow: auto;

  li {
    position: relative;
    padding: ${rem(12)} 0;
    border-bottom: 1px solid ${colors.grey};

    span {
      cursor: pointer;
      display: inline-block;
      width: 100%;
    }

    &:last-child {
      border: 0;
      background: none;
    }
    
    &:not(:last-child):after {
      content: url(${arrow});
      position: absolute;
      top: ${rem(10)};
      right: ${rem(15)};
      transform: rotate(90deg);
      height: ${rem(16)};
      width: ${rem(9)};
    }
  }
`;

const ChannelsList = styled.div`
  display: ${props => (props.open ? 'flex' : 'none')};
  flex-wrap: wrap;
  padding-left: ${rem(20)};

  p {
    font-size: ${rem(12)};
    color: ${colors.darkGrey};
    text-align: center;
    margin-top: ${rem(16)};
  }
`;

const ChannelItem = styled.div`
  margin: ${rem(25)} ${rem(20)} 0 0;
  width: ${rem(70)};
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ImageChannel = styled.div`
  border: 1px solid ${colors.grey};
  border-radius: ${rem(25)};
  width: ${rem(50)};
  height: ${rem(50)};
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: auto;

  img {
    width: ${rem(48)};
    margin: 0;
  }
`;

const ChannelsFooter = styled.div`
  bottom: 0;
  color: ${colors.darkGrey};
  padding: ${rem(10)} 0;
  background: ${colors.mediumGrey};
  text-align: center;
  font-size: ${rem(12)};
  border-top: 1px solid ${colors.grey};
`;

class ChannelsModal extends Component {

  setCategoryInitialStatus = () => {
    const { channelsByCategory } = this.props;
    let categoryOpen = {};

    for (let channel of channelsByCategory) {
      if (!categoryOpen.hasOwnProperty(channel.normalizedCategory)) {
        categoryOpen[channel.normalizedCategory] = false;
      }
    }

    return categoryOpen;
  };

  state = {
    categoryOpen: this.setCategoryInitialStatus(),
  };

  onCategoryClick = (e, category) => {
    e.preventDefault();

    const { categoryOpen } = this.state;
    this.setState({ categoryOpen: { [category]: !categoryOpen[category] } });
  };

  createAudioChannelsTag = (channelsByCategory) => {
    const audioChannels = channelsByCategory.filter(c => c.normalizedCategory === 'Audio' || c.normalizedCategory === 'Radio');
    if (audioChannels) {
      const totalChannels = audioChannels.reduce((total, result) => result.channels.length + total, 0);
      return (<li>E mais {totalChannels} canais de áudio e rádio</li>)
    }
    return null;
  };

  render() {
    const { channelsByCategory, groupName } = this.props;
    const { categoryOpen } = this.state;

    return (
      <ChannelsModalWrapper>
        <h3>Confira os canais que você leva recarregando o Pacote {groupName}</h3>
        <CategoriesList>
          {channelsByCategory
            .filter(c => c.normalizedCategory !== 'Audio' && c.normalizedCategory !== 'Radio')
            .map((c, key) => (
              <li key={key}>
                <span onClick={e => this.onCategoryClick(e, c.normalizedCategory)}>{`${c.category} (${
                    c.channels.length
                } canais)`}</span>
                <ChannelsList open={categoryOpen[c.normalizedCategory]}>
                  {c.channels.map((channel, key) => (
                    <ChannelItem key={key}>
                      <ImageChannel>
                        <img alt="canal" src={channel.imageUrl} />
                      </ImageChannel>
                      <p>{channel.title}</p>
                    </ChannelItem>
                  ))}
                </ChannelsList>
              </li>
            ))}
          {this.createAudioChannelsTag(channelsByCategory)}
        </CategoriesList>
        <ChannelsFooter>*Verifique a disponibilidade</ChannelsFooter>
      </ChannelsModalWrapper>
    );
  }
}

ChannelsModal.propTypes = {
  channelsByCategory: PropTypes.array.isRequired,
  groupName: PropTypes.string.isRequired,
};

export default ChannelsModal;
